import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import { createApp } from 'vue';
import App from './App.vue';
import { initKeycloak, keycloakPlugin } from './plugins/keycloak';
import vuetify from './plugins/vuetify';
import router from './router';
import pinia from './stores';

async function initApp() {
  // Initialize Keycloak BEFORE creating the app
  await initKeycloak(router);

  const app = createApp(App);

  app.use(pinia);
  app.use(router);
  app.use(vuetify);
  app.use(keycloakPlugin);

  app.mount('#app');
}

initApp();
